(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("bi/moser/moser.min"));
	else if(typeof define === 'function' && define.amd)
		define(["bi/moser/moser.min"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("bi/moser/moser.min")) : factory(root["bi/moser/moser.min"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__) {
return 